// extracted by mini-css-extract-plugin
export default {"button":"Button_button__xZ3M9","default":"Button_default__6+d+S","variant2":"Button_variant2__cgYrE","variant3":"Button_variant3__unak-","variant4":"Button_variant4__GPBmA"};